// TODO: Move to a stable createMuiTheme when available
import { unstable_createMuiStrictModeTheme as createMuiTheme } from "@material-ui/core/styles";

export const overridings = {
  name: "Light Theme"
};

const lightTheme = createMuiTheme(overridings);

export { lightTheme };